import { __require as a } from "./main25.js";
import { __require as m } from "./main26.js";
var e, i;
function _() {
  if (i) return e;
  i = 1;
  var o = a(), s = m(), t = "[object Symbol]";
  function b(r) {
    return typeof r == "symbol" || s(r) && o(r) == t;
  }
  return e = b, e;
}
export {
  _ as __require
};
